import { Page } from "@tfg/ui"
import { useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import { useAuth } from "~/store/auth-context.tsx"

export const OrganizationSettings = () => {
  const { user, isAdmin } = useAuth()
  const { t } = useTranslation("organizationSettings")
  const navigate = useNavigate()
  useEffect(() => {
    if (!user?.organization) {
      navigate("/")
    }
  }, [navigate, user?.organization])

  const pages = useMemo(() => {
    const initialPages = [
      {
        label: t("tabs.ProductPages"),
        link: "productpages",
      },
    ]
    if (isAdmin) {
      initialPages.push(
        {
          label: t("tabs.Mapping"),
          link: "mapping",
        },
        {
          label: t("tabs.IngestionSettings"),
          link: "ingestion-settings",
        }
      )
    }

    return initialPages
  }, [t, isAdmin])

  return <Page title={t("title")} pages={pages} />
}
